import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';
import { Button } from '@/components/atoms/Button/Button';
import { Icons } from '@/components/atoms/Icon';

export const FloatingActions = ({
  className,
  actions,
  isSticky,
  direction = 'row',
}: FloatingActionsProps) => {
  return (
    <Box
      className={className}
      sx={{
        position: isSticky ? 'sticky' : 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        gap: sp[16],
        borderTop: '1px solid #d9d9d9',
        background: '#ffffff',
        zIndex: 1,
        '& button, & a': { minWidth: '120px' },
        ...(direction === 'col'
          ? { flexDirection: 'column', p: sp[16] }
          : { p: `${sp[16]} 0` }),
      }}
    >
      {actions?.map((action) => (
        <Button
          key={action.label}
          ariaLabel={action.label}
          variant={action.variant}
          onPress={action.onPress}
          iconLeft={action.iconLeft}
          iconRight={action.iconRight}
          to={action.to}
          isDisabled={action.isDisabled}
        >
          {action.label}
        </Button>
      ))}
    </Box>
  );
};

export interface Action {
  label: string;
  variant?: 'primary' | 'secondary';
  onPress?: () => void;
  iconLeft?: Icons;
  iconRight?: Icons;
  to?: string;
  isDisabled?: boolean;
}
interface FloatingActionsProps {
  className?: string;
  actions: Action[];
  isSticky?: boolean;
  direction?: 'row' | 'col';
}

FloatingActions.displayName = 'FloatingActions';

export default FloatingActions;
